import DupontLogger from "@utils/DupontLogger";

const Logger = DupontLogger("WebPubSubService");

let wsInstance = null;
let reconnectTimer = null;
let messageListeners = [];

const MAX_RECONNECT_DELAY = 30000;
const INITIAL_RECONNECT_DELAY = 1000;
let reconnectDelay = INITIAL_RECONNECT_DELAY;
let currentUrl = null;

const notifyListeners = message => {
  messageListeners.forEach(listener => {
    try {
      listener(message);
    } catch (err) {
      Logger.error("WebPubSub listener error:", err);
    }
  });
};

const connect = url => {
  if (wsInstance) {
    wsInstance.close();
  }

  currentUrl = url;
  reconnectDelay = INITIAL_RECONNECT_DELAY;

  try {
    wsInstance = new WebSocket(url);

    wsInstance.onopen = () => {
      Logger.info("WebPubSub connection established");
      reconnectDelay = INITIAL_RECONNECT_DELAY;
    };

    wsInstance.onmessage = event => {
      try {
        const data = JSON.parse(event.data);
        notifyListeners(data);
      } catch {
        notifyListeners(event.data);
      }
    };

    wsInstance.onerror = error => {
      Logger.error("WebPubSub connection error:", error);
    };

    wsInstance.onclose = event => {
      Logger.info("WebPubSub connection closed:", event.code, event.reason);
      if (currentUrl) {
        scheduleReconnect();
      }
    };
  } catch (error) {
    Logger.error("WebPubSub failed to create connection:", error);
    scheduleReconnect();
  }
};

const scheduleReconnect = () => {
  if (reconnectTimer) {
    clearTimeout(reconnectTimer);
  }
  reconnectTimer = setTimeout(() => {
    if (currentUrl) {
      Logger.info(`WebPubSub reconnecting (delay: ${reconnectDelay}ms)...`);
      connect(currentUrl);
    }
  }, reconnectDelay);
  reconnectDelay = Math.min(reconnectDelay * 2, MAX_RECONNECT_DELAY);
};

const disconnect = () => {
  currentUrl = null;
  if (reconnectTimer) {
    clearTimeout(reconnectTimer);
    reconnectTimer = null;
  }
  if (wsInstance) {
    wsInstance.close();
    wsInstance = null;
  }
  messageListeners = [];
};

const addMessageListener = listener => {
  messageListeners.push(listener);
  return () => {
    messageListeners = messageListeners.filter(l => l !== listener);
  };
};

const isConnected = () => wsInstance?.readyState === WebSocket.OPEN;

const WebPubSubService = {
  connect,
  disconnect,
  addMessageListener,
  isConnected,
};

export default WebPubSubService;
